package dev.lingvo.shared.screenshots.geom

import dev.lingvo.shared.screenshots.doc.Board
import dev.lingvo.shared.screenshots.doc.FrameKind
import dev.lingvo.shared.screenshots.doc.Insets
import kotlin.math.sqrt

/** Keeps captions away from store thumbnail crops; explicit board insets remain the user's authority. */
fun safeArea(board: Board, frameHint: FrameKind? = null): Rect {
    val w = board.canvas.width.toDouble()
    val h = board.canvas.height.toDouble()
    val watchInset = when (frameHint) {
        FrameKind.WATCH_RECT -> .12 * w
        FrameKind.WATCH_ROUND -> (1 - 1 / sqrt(2.0)) * w / 2
        else -> null
    }
    val insets = board.safeArea ?: watchInset?.let { Insets(it, it, it, it) }
        ?: Insets(.04 * h, .05 * w, .04 * h, .05 * w)
    return Rect(insets.left, insets.top, w - insets.left - insets.right, h - insets.top - insets.bottom)
}
